export const styles = {
  mainContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    padding: 0,
    margin: 0,
    width: "100vw",
    height: "100vh",
    overflow: "clip",
  },
};
